import { render, staticRenderFns } from "./TabImport.vue?vue&type=template&id=06fc41e3"
import script from "./TabImport.vue?vue&type=script&lang=js"
export * from "./TabImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports